import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { applyListParams } from "../_shared";
import {
  decorateSchool,
  schoolsListSortMap,
  schoolsSearchCols,
} from "./_helpers";

export const schools_list: Query<Ctx> = async ({ sb }, params) => {
  let query = sb.from("v_schools_list").select("*");
  query = applyListParams(query, params, {
    search: schoolsSearchCols,
    sort: {
      map: schoolsListSortMap,
      default: [{ column: "name" }],
    },
  });
  const { data } = await query;
  if (!data) return [];
  return data.map(decorateSchool);
};
